import React, { Component } from "react";

export default class SortBy extends Component {
  state = {
    listVisible: false
  };
  select = item => {
    if (item) {
      const { onSelectItem } = this.props;
      onSelectItem(item);
    }
  };
  show = () => {
    this.setState({ listVisible: true });
    document.addEventListener("click", this.hide);
  };

  hide = () => {
    this.setState({ listVisible: false });
    document.removeEventListener("click", this.hide);
  };
  renderListItems = () => {
    const list = ["REWARD", "NAME", "SCORE", "DISTANCE"];
    return list.map((listItem, index) => {
      return (
        <div key={index} className="p-15" onClick={() => this.select(listItem)}>
          <span>{this.getShortText(listItem)}</span>
        </div>
      );
    });
  };
  getShortText = orderBy => {
    let shortText;
    switch (orderBy) {
      case "REWARD":
        shortText = "Reward";
        break;
      case "NAME":
        shortText = "A-Z";
        break;
      case "SCORE":
        shortText = "Rating";
        break;
      default:
        shortText = "Distance";
        break;
    }
    return shortText;
  };
  render() {
    const { selectedOrderBy } = this.props;
    const { listVisible } = this.state;

    return (
      <div className={"dropdown-container" + (listVisible ? " show" : "")}>
        <div
          className={"dropdown-display" + (listVisible ? " clicked" : "")}
          onClick={this.show}
        >
          <span>
            Sort by: <label>{this.getShortText(selectedOrderBy)}</label>
          </span>
          <i className="icon icon-arrow-left open" />
        </div>
        <div className="dropdown-list">
          <div>{this.renderListItems()}</div>
        </div>
      </div>
    );
  }
}
